// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3e2a1946","126":"66ee070c","272":"4b630d0e","283":"3b6d5537","453":"821fd3de","509":"d0babbc6","713":"c0eabce0","773":"bdd394ab","780":"8bf9b794","831":"2839ef1d","842":"cd35a8ea"}[chunkId] + ".chunk.js";
};